import { getStateOptions } from "@/nzds/utils/getStateOptions"
import { buildingAreaSchema, standardStringSchema } from "@/schemas"
import { z } from "zod"

const usStateCodes = new Set(getStateOptions("US").map((state) => state.value))

export const editSiteSchema = z
  .object({
    name: standardStringSchema.min(1),
    buildingType: standardStringSchema.default(""),
    buildingArea: buildingAreaSchema,
    addressLine1: standardStringSchema.default(""),
    addressLine2: standardStringSchema.default(""),
    city: standardStringSchema.default(""),
    state: standardStringSchema.default(""),
    postalCode: standardStringSchema.default(""),
    country: standardStringSchema.default(""),
  })
  .superRefine((value, ctx) => {
    const hasAddressInput = [
      value.addressLine1,
      value.addressLine2,
      value.city,
      value.state,
      value.postalCode,
      value.country,
    ].some((field) => field.length > 0)

    if (hasAddressInput && value.city.length === 0) {
      ctx.addIssue({
        code: "custom",
        origin: "address_city_required",
        path: ["city"],
      })
    }

    if (hasAddressInput && value.country.length === 0) {
      ctx.addIssue({
        code: "custom",
        origin: "address_country_required",
        path: ["country"],
      })
    }

    if (
      hasAddressInput &&
      value.country.length > 0 &&
      value.country.length !== 2
    ) {
      ctx.addIssue({
        code: "custom",
        origin: "address_country_invalid_length",
        path: ["country"],
      })
    }

    if (
      value.country.toUpperCase() === "US" &&
      value.state.length > 0 &&
      !usStateCodes.has(value.state.toUpperCase())
    ) {
      ctx.addIssue({
        code: "custom",
        origin: "address_invalid_us_state",
        path: ["state"],
      })
    }
  })

export type EditSiteSchema = z.infer<typeof editSiteSchema>
